import { AxiosResponse } from 'axios';
import { AccountApiResponseType, UserType, AccountType } from 'src/accounts/types';
import { api } from 'src/common/utils';

const ACCOUNTS_ROOT_PATH = 'account_admin';

type UpdateUserOmitType =
  | 'account'
  | 'username'
  | 'is_reseller'
  | 'is_active'
  | 'is_staff'
  | 'is_superuser'
  | 'password'
  | 'is_account_manager'
  | 'can_switch_accounts';

interface UpdateUserType extends Omit<UserType, UpdateUserOmitType> {
  account: string;
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  is_account_manager?: boolean;
  can_switch_accounts?: boolean;
}

export const fetchAccounts = async (
  search: string,
  basicInfo = false
): Promise<AxiosResponse<AccountApiResponseType>> =>
  api.get(
    `/${ACCOUNTS_ROOT_PATH}?search=${search}&page=1&basic_info=${basicInfo ? 'true' : 'false'}`
  );

export const fetchAccount = (accountId: string): Promise<AxiosResponse<AccountType>> =>
  api.get(`/${ACCOUNTS_ROOT_PATH}/${accountId}`);

export const updateUser = (
  userId: string,
  payload: UpdateUserType
): Promise<AxiosResponse<UserType>> => api.patch(`/users/${userId}`, payload);
